import * as React from 'react'
import * as css from './NotificationText.css'

interface Props {
  children: React.ReactChildren
}

export default ({ children }: Props) => <em className={css.component}>{children}</em>
